import {
  type Middleware,
  type Reducer,
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";

import { Api } from "metabase/api";
import { PLUGIN_REDUX_MIDDLEWARES } from "metabase/plugins";
import type { State } from "metabase/redux/store";

// Each app passes its own reducer map, so per-slice types can't be known here.
type AnySliceReducer = Reducer<any, any>;

export function getStore(
  reducers: Record<string, AnySliceReducer>,
  initialState?: Partial<State> | Record<string, unknown>,
  extraMiddlewares: Middleware[] = [],
) {
  // The slice map is dynamic (each app passes its own), so the combined state
  // is typed as a plain record rather than one app's State.
  const reducerMap: Record<string, AnySliceReducer> = {
    ...reducers,
    [Api.reducerPath]: Api.reducer,
  };

  const middlewares: Middleware[] = [
    Api.middleware,
    ...PLUGIN_REDUX_MIDDLEWARES,
    ...extraMiddlewares,
  ];

  return configureStore({
    reducer: combineReducers(reducerMap),
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(middlewares),
  });
}
